module.exports = __webpack_public_path__ + "img/instagamIcon.36a4718.png";